import { authMiddlewareClient, updateShowAppBanner } from "@App/appReducer";
import FullPageLoader from "@Components/FullPageLoader";
import config from "@Config/index";
import { AppState } from "@Store/index";
import useWebViewEvents from "@Utils/webVewEventHandler";
import { parseAppShell } from "constants/appShell";
import { setAppCookies } from "helpers/setCookie";
import useIsApp, { appOS, useAppShell } from "hooks/useIsApp";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

const AppLayout = () => {
  const isApp = useIsApp();
  const appShell = useAppShell();
  const dispatch = useDispatch();
  const { isUserDataFetching } = useSelector(({ appData }: AppState) => ({
    isUserDataFetching: appData.isUserDataFetching,
  }));
  useWebViewEvents();
  useEffect(() => {
    dispatch(updateShowAppBanner(false));
    // Drop the short-lived `is_native_ios` cookie; shell identity is `app_shell` now.
    const clearLegacyNativeIOSCookie = {
      cname: "is_native_ios",
      cvalue: "",
      exdays: -1,
      secure: true,
    };

    if (isApp) {
      const shell = appShell || parseAppShell(window.appShell);
      setAppCookies([
        clearLegacyNativeIOSCookie,
        {
          cname: "is_app",
          cvalue: "true",
          exdays: 7300,
          secure: true,
          domain: `.${config.WEB_SERVICE_HOST}`,
        },
        {
          // OS platform (ios / android). Used by RN and native alike.
          cname: "app_type",
          cvalue: appOS,
          exdays: 7300,
          secure: true,
          domain: `.${config.WEB_SERVICE_HOST}`,
        },
        // `app_shell` is new-native only; RN never sets it — clear any stale value.
        ...(shell
          ? [
              {
                cname: "app_shell",
                cvalue: shell,
                exdays: 7300,
                secure: true,
                domain: `.${config.WEB_SERVICE_HOST}`,
              },
            ]
          : [{ cname: "app_shell", cvalue: "", exdays: -1, secure: true }]),
      ]);
    } else if (!window.isApp) {
      setAppCookies([
        clearLegacyNativeIOSCookie,
        { cname: "is_app", cvalue: "false", exdays: -1, secure: true },
        { cname: "app_type", cvalue: "", exdays: -1, secure: true },
        { cname: "app_shell", cvalue: "", exdays: -1, secure: true },
      ]);
    } else {
      setAppCookies([
        clearLegacyNativeIOSCookie,
        { cname: "is_app", cvalue: "false", exdays: -1, secure: true },
        { cname: "app_type", cvalue: "", exdays: -1, secure: true },
        { cname: "app_shell", cvalue: "", exdays: -1, secure: true },
      ]);
    }
    if (window.localStorage.getItem("user_auth_token")) {
      dispatch(authMiddlewareClient());
    }
  }, []);

  if (isUserDataFetching)
    return (
      <div
        style={{
          position: "fixed",
          zIndex: 1000,
          top: 0,
          left: 0,
          background: "#fff",
          width: "100%",
        }}
      >
        <FullPageLoader />
      </div>
    );

  return <></>;
};

export default AppLayout;
